import Swiper from './swiper.js';

/*H1 Style*/
const headings = document.querySelectorAll('.special-headline');
for (let i = 0; i < headings.length; i++) {
    const heading = headings[i];
    const words = heading.textContent.trim().split(' ');
    const firstWord = words.shift();
    const coloredText = `<span style="color: rgb(0, 152, 234);">${firstWord}</span> ${words.join(' ')}`;
    heading.innerHTML = coloredText;
}


/*Accordion*/
jQuery(document).ready(function($) {
    $('.accordion-header').click(function() {
        $(this).toggleClass('active');
        $(this).next('.accordion-content').slideToggle();
    });
});

/*Kundenstimmen Slider*/
var swiperKundenstimmen = new Swiper('.swiper-container.kundenstimmen', {
    slidesPerView: 1,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});


/*Menu navigation*/
document.addEventListener('DOMContentLoaded', function() {
    const menuItems = document.querySelectorAll('.menu-item');
    const megaMenus = document.querySelectorAll('.mega-menu');

    menuItems.forEach(function(item) {
        const megaMenu = item.querySelector('.mega-menu');
        const icon = item.querySelector('.elementor-icon.icon');
        const iconLink = item.querySelector('.e-font-icon-svg');
        const link = item.querySelector('.first-nav-point');

        if (megaMenu && link && icon) {
            const hasChildren = megaMenu.children.length > 0;
            if (hasChildren) {
                link.addEventListener('click', function(event) {
                    event.preventDefault();
                    if(this.getAttribute('href').trim() !== ''){
                        window.location.href = this.href;
                    }
                    closeOtherMenus(megaMenu);
                    megaMenu.classList.toggle('open');
                    icon.classList.toggle('open');
                });

                iconLink.addEventListener('click', function(event) {
                    event.preventDefault();
                    closeOtherMenus(megaMenu);
                    megaMenu.classList.toggle('open');
                    icon.classList.toggle('open');
                });
            } else {
                link.addEventListener('click', function(event) {
                    closeOtherMenus();
                });
            }
        }
    });

    document.addEventListener('click', function(event) {
        const target = event.target;
        if (!target.closest('.menu-item') && !target.closest('.mega-menu')) {
            closeOtherMenus();
        }
    });

    function closeOtherMenus(excludeMenu = null) {
        megaMenus.forEach(function(megaMenu) {
            if (megaMenu !== excludeMenu && megaMenu.classList.contains('open')) {
                megaMenu.classList.remove('open');
                const icon = megaMenu.previousElementSibling.querySelector('.elementor-icon.icon');
                if (icon) {
                    icon.classList.remove('open');
                }
            }
        });
    }
});

/*Fixed Header*/
window.addEventListener('scroll', function() {
    const header = document.querySelector('.header');

    if (window.pageYOffset > 1) {
        header.classList.add('sticky');
    } else {
        header.classList.remove('sticky');
    }
});
/*Burger Menu*/
window.addEventListener('DOMContentLoaded', function() {
    const menuToggle = document.getElementById('menu_checkbox');
    const offCanvasMenu = document.querySelector('.offcanvas-menu');

    menuToggle.addEventListener('change', function() {
        if (this.checked) {
            offCanvasMenu.classList.add('active');
        } else {
            offCanvasMenu.classList.remove('active');
        }
    });
});

/* OFFCANVAS MENÜ */
document.addEventListener("DOMContentLoaded", function () {
    const dropdownToggles = document.querySelectorAll(".menu-item .first-nav-point .elementor-icon svg, .menu-item .first-nav-point");

    dropdownToggles.forEach(function (toggle) {
        toggle.addEventListener("click", function (event) {
            event.stopPropagation();

            const menuItem = toggle.closest(".menu-item");
            const hasChildren = menuItem.querySelector(".sub-menu") !== null;

            if (hasChildren) {
                event.preventDefault();
                menuItem.classList.toggle("children-active");

                // Wenn es sich um .first-nav-point handelt, füge die Klasse .active hinzu
                if (toggle.classList.contains("first-nav-point")) {
                    toggle.classList.toggle("active");
                }
            }
        });
    });
});


/*Footer Quick Navigation*/
document.addEventListener("DOMContentLoaded", function () {
    const fastNavDropdowns = document.querySelectorAll('.fast-navigation-dropdown');

    fastNavDropdowns.forEach(item => {
        item.addEventListener("click", function () {
            // Deactivate all other dropdowns
            fastNavDropdowns.forEach(otherItem => {
                if (otherItem !== item) {
                    otherItem.classList.remove("active");
                }
            });
            item.classList.toggle("active");
        });
    });
});

/*TABS*/
document.addEventListener("DOMContentLoaded", function () {
    // Tab-Funktionalität
    const tabContainers = document.querySelectorAll('.elementor-element[data-id]');
    tabContainers.forEach(container => {
        const links = container.querySelectorAll('.tab-list-link');
        const contents = container.querySelectorAll('.tab');

        links.forEach(link => {
            link.addEventListener('click', (event) => {
                event.preventDefault();

                links.forEach(l => l.classList.remove('active'));
                link.classList.add('active');

                const dataName = link.getAttribute('data-name');
                contents.forEach(content => content.classList.remove('active'));
                container.querySelector(`#${dataName}`).classList.add('active');
            });
        });
    });

    // Slider-Funktionalität
    const testContainers = document.querySelectorAll('.tabSlider');

    testContainers.forEach(testContainer => {
        const slider = testContainer.querySelector('.my-slider');

        if (slider) {
            let tnsSlider = tns({
                container: slider,
                items: 1,
                slideBy: 'page',
                mouseDrag: 'mouseDrag',
                autoplay: false,
                nav: false,
                prevButton: testContainer.querySelector('.previous'),
                nextButton: testContainer.querySelector('.next'),
                responsive: {
                    800: {
                        items: 2,
                        gutter: 20
                    },
                    1200: {
                        items: 3,
                    }
                }
            });
        }
    });
});


/*Gallery*/
document.addEventListener("DOMContentLoaded", function() {
    var galleryWrappers = document.querySelectorAll(".gallery-items-widget-wrapper");

    galleryWrappers.forEach(function(galleryWrapper) {
        var gallery = galleryWrapper.querySelector(".gallery-itemSpecial");
        var loadMoreButton = galleryWrapper.querySelector("#load-more");
        var images = gallery.querySelectorAll(".gallery-items-widget-item");
        var startIndex = 6;
        var imagesPerLoad = 6;
        var maxImages = 12;

        function loadMoreImages() {
            var endIndex = Math.min(startIndex + imagesPerLoad, maxImages);
            for (var i = startIndex; i < endIndex; i++) {
                if (i >= images.length) {
                    loadMoreButton.style.display = "none";
                    break;
                }
                images[i].style.display = "block";
            }
            startIndex = endIndex;

            if (startIndex >= maxImages) {
                loadMoreButton.style.display = "none";
            }
        }

        loadMoreButton.addEventListener("click", loadMoreImages);

        if (images.length <= startIndex) {
            loadMoreButton.style.display = "none";
        }
    });
});


// Service Teaser
// Check current page: modify appearance of teaser which belongs to current page

let serviceTeaser = document.getElementsByClassName('service-teaser');

    if(serviceTeaser.length){
        // Get the pathname
        let pathname = window.location.pathname;
        let cleanPathname = pathname.replace(/\//g, '');


        Array.from(serviceTeaser).forEach(element => {
            let heading = element.querySelector('.elementor-heading-title a').innerHTML.toLowerCase();
            let headingElement = element.querySelector('.elementor-heading-title a');
            let link = element.querySelector('.elementor-icon-list-item');
            let overlay = element.querySelector('.service-teaser-overlay');
            let image = element.querySelector('.elementor-widget-image a');
            //if the heading is the same as the page title, modify the layout (active state)

            if(heading == cleanPathname){
                element.classList.add('active-teaser');
                link.style.visibility = 'hidden';
                overlay.style.visibility = 'visible';
                overlay.style.opacity = '1';
                headingElement.removeAttribute("href");
                image.removeAttribute("href");
            }
        });


    }
